import { render } from "./customer_fields.vue?vue&type=template&id=64ab9374"
import script from "./customer_fields.vue?vue&type=script&lang=js"
export * from "./customer_fields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__